export default __webpack_public_path__ + "static/media/news-ART-XC.f262491a.JPG";